<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: "IconCar1"
})
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="51" height="24">
        <path
            d="M48.7 12c-.1-.1-.3-.2-.5-.3C45.9 10 41.7 9 41.7 9l-1-3c-.5-1.5-1-2-1-2h-9 .3v13h-1V0H0v19h9.8s1-2 4-2 4 2 4 2H25v1h-.2 15s.6-3 4-3 4 3 4 3H51v-3h-.1v-1c0-1-.5-2.6-2.2-4"/>
        <circle cx="13.8" cy="21" r="3"/>
        <circle cx="43.7" cy="21" r="3"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
